import { Box, ColorOptions, convertHexToRGBA, ModBox, Spacer, Text } from '@jfs/ui-new'

export const MerchantDetail = ({ merchantName, vpa, color }: any) => {
  return (
    <Box alignItems="center" justify="center" mt={0}>
      <Text fontSize={18} color={color} fontFamily={'JioType-Bold'} weight={'dense'}>
        {merchantName}
      </Text>
      <Spacer size={8} direction="vertical" />
      <Box>
        <ModBox show={vpa?.length > 0}>
          <Text color={convertHexToRGBA(color, 70) as ColorOptions} fontSize={14} fontFamily={'JioType-Medium'}>
            UPI ID: {vpa}
          </Text>
        </ModBox>
      </Box>
    </Box>
  )
}
